import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import ChevronLeftIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/ChevronLeft';

export const ChevronLeftIconStyled = styled(ChevronLeftIcon)`
  ${({ theme }) => {
    return css`
      margin-right: ${rem(4)};
      color: ${theme.colors.gold.gold}
    `;
  }}
`;

export const LinkStyled = styled(Link)`
  display: inline-block;
  line-height: ${rem(24)};
  padding-bottom: ${rem(10)};
`;

export const LinkStyledBack = styled(Link)`
  display: inline-block;
  padding-bottom: ${rem(24)};
`;

export const TypographyStyled = styled(Typography)`
  && {
    margin-bottom: ${rem(32)};
    border-bottom: ${rem(1)} solid;
  }
`;
